// https://www.w3schools.com/colors/colors_picker.asp
enum Color {
  Black = "#000",
  Gray = "#888",
  Gray90 = "#e6e6e6",
  Gray75 = "#bfbfbf",
  Primary = "#ff9933",
  PrimaryLight85 = "#ffd9b3",
  PrimaryLight95 = "#fff2e6",
  Red = "#800",
  Red40 = "#d32f2f",
  White = "#FFF",
  BKash = "#d63384",
}

export default Color
